export default __webpack_public_path__ + "static/media/port21.d97bfba5.jpg";